export const ErrorCodes = {
  FILE_PASSWORD_REQUIRED: 1002,
  FILE_PASSWORD_MISMATCH: 1003,
  FILE_ACCESS_DENIED: 1004,
  FILE_NOT_SHARED: 1005,
  FILE_NOT_FOUND: 1011,
  FILE_PERMISSION_DENIED: 7002,
};
